import { AfterViewInit, Component } from '@angular/core';
import { AI_TOKEN_METER_SHOWCASE } from '../../../../data/product/ai-token-meter-features.data';
import { COLOR_PICKERS_SHOWCASE } from '../../../../data/product/color-pickers.data';
import { DOCK_TOWN_SHOWCASE } from '../../../../data/product/dock-town-features.data';
import { LANGMI_SHOWCASE } from '../../../../data/product/langmi-features.data';
import { ShowcaseConfig } from '../../../../data/product/product-features.data';
import { TIDY_DESKTOP_SHOWCASE } from '../../../../data/product/tidy-desktop-features.data';

// The /plugins landing page, laid out as the home (owner 2026-10-12): the hero band with a chip per product,
// then every app, extension and plugin as the home's box (product-showcase.component.ts), one under the
// other, in the home's order (owner 2026-10-12: All In One Themes not among them). The URL stays /plugins, so
// every existing link and the pages underneath it keep working.
@Component( {
  selector: 'app-plugins-page',
  templateUrl: './plugins-page.component.html',
  styleUrls: [ '../../tool-pages/tools-page/tools-page.component.scss', './plugins-page.component.scss' ],
} )
export class PluginsPageComponent implements AfterViewInit {

  readonly boxes: { id: string; name: string; icon: string; config: ShowcaseConfig }[] = [
    { id: 'dock-town', name: 'Dock Town', icon: DOCK_TOWN_SHOWCASE.icon, config: DOCK_TOWN_SHOWCASE },
    { id: 'tidy-desktop', name: 'Tidy Desktop', icon: TIDY_DESKTOP_SHOWCASE.icon, config: TIDY_DESKTOP_SHOWCASE },
    { id: 'langmi', name: 'LangMi', icon: LANGMI_SHOWCASE.icon, config: LANGMI_SHOWCASE },
    { id: 'color-pickers', name: 'Color Pickers', icon: './assets/product-lines/tools/color-picker-512.png', config: COLOR_PICKERS_SHOWCASE },
    // AI Token Meter after the Color Pickers, as on the home (owner 2026-10-28)
    { id: 'ai-token-meter', name: 'AI Token Meter', icon: AI_TOKEN_METER_SHOWCASE.icon, config: AI_TOKEN_METER_SHOWCASE },
  ];

  // the platform sections the page had before (/plugins#chrome-extensions and the like), each landing on the
  // first box of its platform now
  private static readonly OLD_SECTIONS: Record<string, string> = {
    'macos-apps': 'dock-town',
    'ios-apps': 'langmi',
    'chrome-extensions': 'color-pickers',
    'jetbrains-plugins': 'color-pickers',
    'vscode-extensions': 'color-pickers',
  };

  /** A link to a box (/plugins#langmi), or to one of the old platform sections, lands on it. */
  ngAfterViewInit(): void {
    const hash = typeof location !== 'undefined' ? location.hash.replace( '#', '' ) : '';
    const id = PluginsPageComponent.OLD_SECTIONS[ hash ] || hash;
    if ( id && this.boxes.some( b => b.id === id ) ) {
      setTimeout( () => this.jumpTo( id ) );
    }
  }

  /**
   * A product chip in the hero: scroll to its box instead of leaving the page, put the keyboard focus there
   * (so Tab goes on into the box) and keep the box in the URL.
   */
  jumpTo( id: string, event?: Event ): void {
    event?.preventDefault();
    const box = document.getElementById( id );
    if ( !box ) { return; }
    box.scrollIntoView( { behavior: 'smooth', block: 'start' } );
    box.focus( { preventScroll: true } );
    history.replaceState( history.state, '', '/plugins#' + id );
  }
}
